import { BigCommerceCart } from '@/types/bigcommerce';
import { log } from '@/utils';

export const getBigCommerceCart = async (): Promise<BigCommerceCart | null> => {
  try {
    const res = await fetch('/api/storefront/cart');
    const data = await res.json();
    return data[0];
  } catch (error) {
    log.error('Failed to fetch cart.');
    return null;
  }
};
